import { PersonLookup } from '../models/views.models';

const NAMES = [
  'Valeria Acosta', 'Hernán Bustos', 'Mariana Caputo', 'Federico Duarte', 'Lorena Echeverría',
  'Gastón Funes', 'Silvina Godoy', 'Emiliano Herrera', 'Noelia Ibáñez', 'Rodrigo Juárez',
];
const COMPANY_NAMES = ['Distribuidora Andina SRL', 'Servicios Integrales Norte SA', 'Estudio Jurídico Paz y Asociados', 'Transporte Rápido Sur SRL'];
const STREETS = ['Av. Santa Fe', 'Lavalle', 'Sarmiento', 'Belgrano', 'Mitre', 'Av. Libertador'];
const CITIES = ['CABA', 'Rosario', 'Córdoba', 'La Plata'];

/**
 * M-05: the normalization service knows some documents and not others.
 * A document is "known" when its last digit is 0 to 5, so the demo is predictable.
 */
export function normalizeDocument(documentNumber: string): PersonLookup['normalized'] {
  const digits = documentNumber.replace(/\D/g, '');
  if (digits.length < 7 || Number(digits[digits.length - 1]) > 5) return null;
  const n = Number(digits.slice(-6));
  const legal = digits.length === 11;
  const year = 1960 + (n % 40);
  const month = String(1 + (n % 12)).padStart(2, '0');
  const day = String(1 + (n % 28)).padStart(2, '0');
  return {
    legalForm: legal ? 'legal' : 'natural',
    displayName: legal ? COMPANY_NAMES[n % COMPANY_NAMES.length] : NAMES[n % NAMES.length],
    birthDate: legal ? null : `${year}-${month}-${day}`,
    address: `${STREETS[n % STREETS.length]} ${100 + (n % 4700)}, ${CITIES[n % CITIES.length]}`,
  };
}
